var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackRenards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_777",
    "data-name": "Groupe 777",
    transform: "translate(9811.5 6925.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    transform: "translate(-9811.5 -6925.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_40",
    "data-name": "Ligne 40",
    x2: 10.792,
    transform: "translate(-9798.321 -6907.804)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_41",
    "data-name": "Ligne 41",
    x1: 2.761,
    y2: 2.761,
    transform: "translate(-9798.321 -6910.565)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_42",
    "data-name": "Ligne 42",
    x1: 2.761,
    y1: 2.761,
    transform: "translate(-9798.321 -6907.804)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackRenards);
export default __webpack_public_path__ + "static/media/back_renards.1e4a414d214f356dfc7eb4c83a2f67f8.svg";
export { ForwardRef as ReactComponent };